const station_store = {
    subscribers:{},
    stations:[],
    selected: undefined, 
    getStation(station_id){
        return this.stations.filter(x=>x.id == station_id)[0]
    },
    getStationsByIds(ids){
        return this.stations.filter(x=>ids.includes(x.id))
    },
    setStations(stations){
        this.stations = stations
        this.publish('SET_STATIONS',{stations:this.getStations()})
    },
    getStations(){
        return this.stations
    },
    setStationMeasurements(station_id, measurements){
        let station = this.getStation(station_id)
        station.measurements = measurements
        this.publish('SET_STATION_MEASUREMENTS', {station_id:station_id, measurements:station.measurements})
    },
    setStationDelayStatus(station_id,string){
        let station = this.getStation(station_id)
        station.delay_status = string
        this.publish('SET_STATION_DELAY_STATUS', {station_id:station_id, status:string})
    },
    setStationProp(station_id, prop, value){
        let station = this.getStation(station_id)
        station[prop] = value
        this.publish('SET_STATION_PROP', {station_id:station_id, prop: prop, value:value})
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default station_store